import { render, staticRenderFns } from "./integrateDoorWallCabinet.vue?vue&type=template&id=4b1ae56e&scoped=true&"
import script from "./integrateDoorWallCabinet.vue?vue&type=script&lang=js&"
export * from "./integrateDoorWallCabinet.vue?vue&type=script&lang=js&"
import style0 from "./integrateDoorWallCabinet.vue?vue&type=style&index=0&id=4b1ae56e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1ae56e",
  null
  
)

export default component.exports